import Logger from 'components/Common/Logger';
import http from 'utils/http';
import { call, put } from 'redux-saga/effects';
import {
  fetchFlowNodeCompleteDetailsError,
  updateSingleNodeData,
} from 'redux/actions/FlowAction';
import { showAlert } from 'redux/actions/AlertActions';


export function* fetchFlowNodeCompleteDetails({ url, payload }) {
  const { nodeId } = payload;
  const { error, node } = yield call(http.get, url);

  if (error) {
    Logger.error(error, `Could not fetch flow node complete details. Url: ${url}. Error: ${error}`);
    yield put(showAlert({ message: error, type: 'error' }));
    return yield put(fetchFlowNodeCompleteDetailsError(payload));
  }

  return yield put(updateSingleNodeData(nodeId, node));
}
